import GalleriesTable from "./GalleriesTable";

export default GalleriesTable;
